import { render, staticRenderFns } from "./ThinMale.vue?vue&type=template&id=87e05608&scoped=true&"
import script from "./ThinMale.vue?vue&type=script&lang=js&"
export * from "./ThinMale.vue?vue&type=script&lang=js&"
import style0 from "./ThinMale.vue?vue&type=style&index=0&id=87e05608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e05608",
  null
  
)

export default component.exports